import { FirstTouchAttribution } from './types';

const FIRST_TOUCH_STORAGE_KEY = 'noblewills:first-touch-attribution:v1';
const MAX_VALUE_LENGTH = 256;

const queryFields: Record<string, keyof FirstTouchAttribution> = {
    utm_source: 'utmSource',
    utm_medium: 'utmMedium',
    utm_campaign: 'utmCampaign',
    utm_term: 'utmTerm',
    utm_content: 'utmContent',
    gclid: 'gclid',
    gbraid: 'gbraid',
    wbraid: 'wbraid',
    dclid: 'dclid',
    msclkid: 'msclkid',
    fbclid: 'fbclid',
    ttclid: 'ttclid',
    li_fat_id: 'liFatId',
};

export class FirstTouchAttributionService {
    static get(): FirstTouchAttribution | undefined {
        if (typeof window === 'undefined') return undefined;
        try {
            const value = window.localStorage.getItem(FIRST_TOUCH_STORAGE_KEY);
            if (!value) return undefined;
            const parsed = JSON.parse(value) as FirstTouchAttribution;
            if (parsed.version !== 1) return undefined;
            if (!parsed.attributionId) {
                parsed.attributionId = this._newAttributionId();
                window.localStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(parsed));
            }
            return parsed;
        } catch (_) {
            return undefined;
        }
    }

    static capture(locale: string): FirstTouchAttribution | undefined {
        if (typeof window === 'undefined') return undefined;

        const existing = this.get();
        if (existing) return existing;

        const params = new URLSearchParams(window.location.search);
        const attribution: FirstTouchAttribution = {
            version: 1,
            attributionId: this._newAttributionId(),
            landingPath: window.location.pathname,
            locale,
            capturedAt: new Date().toISOString(),
        };

        Object.entries(queryFields).forEach(([queryKey, field]) => {
            const value = params.get(queryKey)?.trim();
            if (value) attribution[field] = value.slice(0, MAX_VALUE_LENGTH) as never;
        });

        try {
            window.localStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(attribution));
            return attribution;
        } catch (_) {
            return undefined;
        }
    }

    static toForwardingValue(attribution: FirstTouchAttribution | undefined): string | undefined {
        if (!attribution || typeof window === 'undefined') return undefined;
        try {
            return window.btoa(unescape(encodeURIComponent(JSON.stringify(attribution))));
        } catch (_) {
            return undefined;
        }
    }

    private static _newAttributionId(): string {
        return typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}
